export default "/kiban/_next/static/images/btn_first-5b8fb66cf82dd26d2da4640906ce04c2.png";